import { useEffect, useState } from 'react'
import css from '../../assets/css/notification.module.css'
import { apiRequest } from '../../apiService/allApi'

const Notification = () => {
  const [notifications, setNotifications] = useState([])

  const access_token = localStorage.getItem('token')

  useEffect(() => {
    notification_list()
  }, [])

  const notification_list = async () => {
    var myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${access_token}`)
    myHeaders.append('Content-Type', 'application/json')

    const result = await apiRequest('list-notification/sendto/all?page=1&limit=10',"GET",null,myHeaders)

        setNotifications(result.results)

  }

  function formatDate (dateString) {
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }
    return new Date(dateString).toLocaleString('en-US', options)
  }

  return (
    <>
      <div>
        <div className='leftContainer page_layout'>
          <div className='Orher_page_main_section'>
            <h2 className='profile_headings'>Notifications</h2>

                {notifications && notifications.length > 0 ? (
                  notifications.map((items) => {
                    const baseUrl =
                      process.env.REACT_APP_API_BASE_URL ||
                      "https://bk.kingmastar.in";
                    let notifImg = items?.image;
                    if (
                      notifImg &&
                      typeof notifImg === "string" &&
                      !notifImg.startsWith("http")
                    ) {
                      notifImg = `${baseUrl}${
                        notifImg.startsWith("/") ? "" : "/"
                      }${notifImg}`;
                    }

                    return (
                      <div
                        className="other_pages_card_main"
                        key={items._id || items.id}
                        style={{ flexDirection: "column", alignItems: "flex-start" }}
                      >
                        <div style={{ width: "100%" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                            <h3>{items?.title}</h3>
                            <span style={{ fontSize: "11px", color: "#94a3b8", whiteSpace: "nowrap", marginLeft: "8px" }}>
                              {formatDate(items.createdAt)}
                            </span>
                          </div>
                          <p style={{ marginTop: "4px", color: "#475569", fontSize: "13px" }}>
                            {items?.message || items?.title}
                          </p>
                        </div>
                        {notifImg && (
                          <div
                            style={{
                              marginTop: "10px",
                              borderRadius: "10px",
                              overflow: "hidden",
                              width: "100%",
                              maxHeight: "180px",
                              border: "1px solid #e2e8f0",
                              backgroundColor: "#f8fafc",
                            }}
                          >
                            <img
                              src={notifImg}
                              alt="Notification"
                              style={{
                                width: "100%",
                                height: "auto",
                                maxHeight: "180px",
                                objectFit: "cover",
                                display: "block",
                              }}
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className='empty-notification-box'>
                    <div
                      className='cxy flex-column px-4 text-center'
                      style={{ paddingTop: '30%' }}
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL + '/images/nonotification.png'
                        }
                        width='220px'
                        className='snip-img'
                        alt='no notification'
                      />
                      <div
                        className={`${css.games_section_title} mt-4`}
                        style={{ fontSize: '1.2em' }}
                      >
                        No notification yet!
                      </div>
                      <div
                        className={`${css.games_section_headline} mt-2`}
                        style={{ fontSize: '0.85em' }}
                      >
                        Seems like you haven’t done any activity yet
                      </div>
                    </div>
                  </div>
                )}
              </div>
        </div>
      </div>
    </>
  )
}

export default Notification
